module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.slotComponent) ? _c(_vm.slotComponent, _vm._g(_vm._b({
    tag: "component",
    staticClass: "slot-header"
  }, 'component', _vm.slotProps, false), _vm.$listeners)) : _c('div', {
    staticClass: "default-header"
  }, [_c('div', _vm._g({
    staticClass: "default-header_title",
    staticStyle: {
      "-webkit-box-orient": "vertical"
    }
  }, _vm.$listeners), [_vm._v(_vm._s(_vm.title))]), _c('div', {
    staticClass: "default-header_buttons"
  }, [_c('div', {
    staticClass: "close_wrapper"
  }, [_c('button', {
    staticClass: "close",
    on: {
      "click": _vm.close
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d236ef8","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppModal/components/Header.vue
// module id = 4d173573fa5f49b07973
// module chunks = 89